import axios from './axios';

/**
 * Performs an ABN (Australian Business Number) lookup
 * 
 * @param {string} token - Authentication token
 * @param {string} entityType - Type of entity (e.g., 'application')
 * @param {string} entityId - ID of the entity (e.g., applicationId)
 * @param {string} abn - The ABN to look up
 * @returns {Promise<Object>} - The response from the API
 */
export const abnLookup = async (token, entityType, entityId, abn) => {
  try {
    const response = await axios.post( `/utility/abnLookup`, {   entityId : entityId, entityType : entityType,  abn: abn  }, {  headers: {  Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    console.error('ABN Lookup Error:', error);
    return {
      error: 1,
      message: error.response?.data?.message || 'An error occurred during ABN lookup'
    };
  }
};

/**
 * Performs an ACN (Australian Company Number) lookup
 * 
 * @param {string} token - Authentication token
 * @param {string} entityType - Type of entity (e.g., 'application')
 * @param {string} entityId - ID of the entity (e.g., applicationId)
 * @param {string} acn - The ACN to look up
 * @returns {Promise<Object>} - The response from the API
 */
export const acnLookup = async (token, entityType, entityId, acn) => {
  try {
    const response = await axios.post( `/utility/acnLookup`, {   entityId : entityId, entityType : entityType,  acn: acn  }, {  headers: {  Authorization: `Bearer ${token}` } });
    
    return response.data;
  } catch (error) {
    console.error('ACN Lookup Error:', error);
    return {
      error: 1,
      message: error.response?.data?.message || 'An error occurred during ACN lookup'
    };
  }
};

// Export all functions
export default {
  abnLookup,
  acnLookup
};
